__turbopack_context__.v({
  "card": "-QnX1W_card",
  "footerInitializing": "-QnX1W_footerInitializing",
  "layout": "-QnX1W_layout",
  "page": "-QnX1W_page",
});
